import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import classNames from 'classnames';

class Timeline extends Component {
    constructor() {
        super();
        this.state = {
          viewportWidth: 0,
          viewportHeight: 0
        }
      }

    updateDimensions() {
        this.setState({ viewportWidth: window.innerWidth, viewportHeight: window.innerHeight });
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    render() {
        const { currentStep } = this.props;
        const { viewportWidth, viewportHeight } = this.state;

        console.log('viewportWidth: '+viewportWidth);

        return (
            <div className="row">
                <ul className="stepper stepper-horizontal align-self-center">
                    {this.props.steps.map(function(name, index){
                    index++;
                    return (
                    <>
                        {(false) && (
                            <li id={"stepper-li step-"  + index} key={ index } className={classNames({ "completed": index < currentStep, "active": currentStep === index, "step-4": index === 4 })}>
                                <div className="row">
                                    <div className="col-1 col-sm-3 step-number-pos" style={{opacity: (currentStep >= index ? "1.0" : "0.4")}}>
                                        {/*blue-font-68-gelo-vw*/}
                                        <span className="blue-font-68-gelo">{index}</span>
                                    </div>
                                    <div className="col col-sm-9" style={{opacity: (currentStep >= index ? "1.0" : "0.4")}}>
                                        {/*blue-font-20-euclid-vw*/}
                                        {/*blue-font-17-euclid*/}
                                        <span className="number blue-font-20-euclid mobile-step-name" dangerouslySetInnerHTML={{__html: name}}></span>
                                    </div>
                                </div>
                            </li>
                        )}

                        {(true) && (
                            <li id={"stepper-li step-"  + index}  key={ index } className={classNames({ "completed": index < currentStep, "active": currentStep === index, "step-4": index === 4 })} style={{opacity: (currentStep >= index ? "1.0" : "0.4")}}>
                                <span 
                                    className={"form-index-number step-"  + index} 
                                    style={{
                                        opacity: (currentStep >= index ? "1.0" : "0.4"), 
                                        }}>
                                            {index}
                                </span>
                                <span 
                                    className="form-index-name"
                                    style={{
                                        opacity: (currentStep >= index ? "1.0" : "0.4"), 
                                        }}
                                    dangerouslySetInnerHTML={{__html: name}}>
                                </span>
                            </li> 
                        )}
                    </>
                    )})}
                </ul>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
  const { currentStep } = state;
  return { currentStep: currentStep };
}

export default connect(mapStateToProps, actions)(Timeline);